export type LocationIdentifier = { id?: string; type?: string } | null | undefined

/** Returns true if both locations have the same id and type (filters should be preserved). */
export const isSameLocation = (a: LocationIdentifier, b: LocationIdentifier): boolean => {
  if (!a || !b) return false
  return a.id === b.id && a.type === b.type
}

const makeLocationParser =
  (idKey: string, typeKey: string) =>
  (searchParams: URLSearchParams): { id: string; type: string } | undefined => {
    const id = searchParams.get(idKey)
    const type = searchParams.get(typeKey)
    return id && type ? { id, type } : undefined
  }

export const parseCarHireLocationFromUrl = makeLocationParser(
  'pickUpLocation[id]',
  'pickUpLocation[type]'
)
export const parseDestinationFromUrl = makeLocationParser('destination[id]', 'destination[type]')
// Hotels use dest_id/dest_type (set by stringifyHotelSearchFormToQuery), not the qs-serialised destination[...] shape
export const parseHotelUrlDestination = makeLocationParser('dest_id', 'dest_type')
